import { EMVMetrics, EMVRates } from '../types/socialMedia';

// Default EMV rates based on provided formula
export const DEFAULT_EMV_RATES: EMVRates = {
  viewRate: 0.01,     // $0.01 per view
  commentRate: 0.50,  // $0.50 per comment
  likeRate: 0.10,     // $0.10 per like
  shareRate: 1.00     // $1.00 per share
};

/**
 * Calculate EMV using the provided formula:
 * EMV = (Views × $0.01) + (Comments × $0.50) + (Likes × $0.10) + (Shares × $1.00)
 */
export const calculateEMV = (metrics: EMVMetrics, rates: EMVRates = DEFAULT_EMV_RATES): number => {
  const emv = (metrics.views * rates.viewRate) +
              (metrics.comments * rates.commentRate) +
              (metrics.likes * rates.likeRate) +
              (metrics.shares * rates.shareRate);

  return Math.round(emv * 100) / 100; // Round to 2 decimal places
};

/**
 * Format EMV value as currency
 */
export const formatEMV = (emv: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(emv);
};